export default __webpack_public_path__ + "627aa72493cced6656b0c34571fb3982.png";